import DefaultLayout from 'layouts/default';
import './index.css';
import { Table, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
const ManiSkill2ChallengeResultsPage = () => {
  return (
    <DefaultLayout>
      <div className="ManiSkill2ChallengeResultsPage">
      <Typography variant="h3">ManiSkill2 Results</Typography>
      <Typography variant="body1">Awards and results of the ManiSkill2 Challenge</Typography>
      <br />
      <Typography variant="body1">The final evaluation results can be found here: 
        <Link to="/challenges/ms2-stage2">
          https://sapien.ucsd.edu/challenges/maniskill/challenges/ms2-stage2</Link></Typography>
      <Typography variant="h4">Awards</Typography>
      <Typography variant="h5">Imitation Learning/Reinforcement Learning Track (Rigid Body)</Typography>
      <Table style={{ margin: '20px 0' }}>
        <TableHead>
          <TableCell></TableCell>
          <TableCell>Team Name</TableCell>
          <TableCell>Affiliation</TableCell>
          <TableCell>Members</TableCell>
        </TableHead>
        <TableRow>
          <TableCell>1st Prize</TableCell>
          <TableCell>GXU-LIPE</TableCell>
          <TableCell>Guangxi University, University of Science and Technology of China</TableCell>
          <TableCell>
            Xuetao Li, Fang Gao, Feng Shuang, Jun Yu
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>2nd Prize</TableCell>
          <TableCell>baochen</TableCell>
          <TableCell>
            Shanghai Jiaotong University
          </TableCell>
          <TableCell>Chen Bao</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>3rd Prize</TableCell>
          <TableCell>yeok</TableCell>
          <TableCell>Hong Kong Polytechnic University</TableCell>
          <TableCell>Cheah Yeok Tatt</TableCell>
        </TableRow>
      </Table>
      <Typography variant="h5">No Restriction (Rigid Body)</Typography>
      <Table style={{ margin: '20px 0' }}>
        <TableHead>
          <TableCell></TableCell>
          <TableCell>Team Name</TableCell>
          <TableCell>Affiliation</TableCell>
          <TableCell>Members</TableCell>
        </TableHead>
        <TableRow>
          <TableCell>1st Prize</TableCell>
          <TableCell>GXU-LIPE</TableCell>
          <TableCell>Guangxi University, University of Science and Technology of China</TableCell>
          <TableCell>
            Xuetao Li, Fang Gao, Feng Shuang, Jun Yu
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>2nd Prize</TableCell>
          <TableCell>baochen</TableCell>
          <TableCell>
            Shanghai Jiaotong University
          </TableCell>
          <TableCell>Chen Bao</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>3rd Prize</TableCell>
          <TableCell>yeok</TableCell>
          <TableCell>Hong Kong Polytechnic University</TableCell>
          <TableCell>Cheah Yeok Tatt</TableCell>
        </TableRow>
      </Table>
      <Typography variant="h5">No Restriction (Soft Body)</Typography>
      <Table style={{ margin: '20px 0' }}>
        <TableHead>
          <TableCell></TableCell>
          <TableCell>Team Name</TableCell>
          <TableCell>Affiliation</TableCell>
          <TableCell>Members</TableCell>
        </TableHead>
        <TableRow>
          <TableCell>1st Prize</TableCell>
          <TableCell>GXU-LIPE</TableCell>
          <TableCell>Guangxi University, University of Science and Technology of China</TableCell>
          <TableCell>
            Xuetao Li, Fang Gao, Feng Shuang, Jun Yu
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>2nd Prize</TableCell>
          <TableCell>baochen</TableCell>
          <TableCell>
            Shanghai Jiaotong University
          </TableCell>
          <TableCell>Chen Bao</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>3rd Prize</TableCell>
          <TableCell>yeok</TableCell>
          <TableCell>Hong Kong Polytechnic University</TableCell>
          <TableCell>Cheah Yeok Tatt</TableCell>
        </TableRow>
      </Table>
      <Typography variant="body1"></Typography>
      </div>
    </DefaultLayout>
  );
};

export default ManiSkill2ChallengeResultsPage;
